import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const Wrapper = withViewportStyle("div")`
  display: grid;
  grid-auto-rows: max-content;
  gap: ${rem(16)};

  ${(props) => props.$viewport.mobile`
    gap: ${rem(8)};
  `}
`;

export const CTAButtonWrapper = withViewportStyle("div")`
  width: max-content;
  max-width: ${rem(300)};
  margin-top: ${rem(8)};

  ${(props) => props.$viewport.mobile`
    width: 100%;
    max-width: 100%;
    margin-top: ${rem(24)};
  `}
`;
